import {
	triggerCompletePurchasesHideDeliveredDisabledEvent,
	triggerCompletePurchasesHideDeliveredEnabledEvent,
} from 'Services/analytics/events';

export const triggerDeliveredToggleSnowplowEvent = (hideDelivered: boolean): void =>
	hideDelivered
		? triggerCompletePurchasesHideDeliveredDisabledEvent()
		: triggerCompletePurchasesHideDeliveredEnabledEvent();
